import { generateAssetCdnUrl } from '@tickled-media/web-components.tm-helpers';
import React, { Fragment } from 'react';
// import style from './style.css';
// import {Icon} from '../Icon';
import cx from '../../../styles';
// import { translate } from 'react-i18next';
import AL from '../../Common/CardComponents/ActionLink';
import RB from '../../Common/CardComponents/ResponseBar';
import {makeRoute, gtmSend} from '../../../helpers';

export const ActionLink = AL;

export const ResponseBar = RB;

export const TopicLink = ({slug, name, background = "",appReducer, cardName, match}) => {

    const handleTopicClick = () => {
        if(cardName){
            gtmSend('dynamic', cardName, 'click-topic', slug, match.path)
        }
    }

    let style1 = {}
    let style2 = {}
    if(background) {
        style1 = {color: background}
        style2 = {background: background}
    }
    return(
        <div className={cx("topic-link")} onClick={() => handleTopicClick()}>
            <div style={style2}></div>
            <a style={style1} href={makeRoute(`/topic/${slug}`,appReducer)}>{name}</a>
        </div>
    )
}

export const AuthorLink = ({slug,fullName, tagLine, imageUrl, imageThumbSize = "", cardName, match}) => {

    const handleAuthorClick = () => {
        if(cardName){
            gtmSend('dynamic', cardName, 'click-author', slug, match.path)
        }
    }

    const content = <Fragment>
                    <div className={cx("profile-img-wrap")}>
                        <ProfileThumb img={imageUrl} size={imageThumbSize} altName={`${fullName} profile icon`} />
                    </div>

                    <div className={cx("author-name")}>
                        <div>{fullName}</div>
                        { tagLine && <p><span>{tagLine}</span></p>}
                    </div>
                  </Fragment>

    return(
        <div className={cx("author-link")} onClick={() => handleAuthorClick()}>
            {
                slug.length > 0
                ?
                    <a href={slug} className={cx("author-wrap")}>
                        {content}
                    </a>
                :
                    <div className={cx("author-wrap")}>
                        {content} 
                    </div>
            }
        </div>
    )
}

export const LastSeen = ({lastSeen, url, match, cardName, isSingleReplyLastSeen, botIndex}) => {
    const handleLastSeenClick = () => {
        if(cardName){
            gtmSend('dynamic', cardName, 'click-date', match.path)
        }
    }

    if(url){
        let relValue = {};
        if(!botIndex){
            relValue = {
                rel: "nofollow"
            };
        }
        
        return(
            <div className={cx("last-seen","reply-card-seen")} onClick={() => handleLastSeenClick()}>
                <a href={url} {...relValue}>
                    {lastSeen}
                </a>
            </div>
        )
    }
    else{
        return(
            <div className={cx("last-seen", isSingleReplyLastSeen ? 'reply-card-seen' : '')} onClick={() => handleLastSeenClick()}>{lastSeen}</div>
        )
    }
}

/*
size: small | mini | large | xlarge
 */
export const ProfileThumb = ({img, size, altName}) => {
    if(typeof img == "undefined" || img == "") {
        img = generateAssetCdnUrl("parenttown-prod", "profile_15637872962857.jpg");
    }

    if(typeof size == "undefined" || size == "") {
        size = "small";
    }

    return <img className={cx("profile-thumb", size)} src={img} alt={altName} loading="lazy"/>;

    /*if(topicName){
        return <img className={cx("profile-thumb", size)} src={img} alt={topicName} loading="lazy"/>
    }

    return (
        <div className={cx("profile-thumb", size)} 
            style={{backgroundImage: "url("+img+")"}}></div>
    )*/
}
